var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.iframeSrc)?_c('iframe',{staticClass:"cs-badge-iframe",attrs:{"src":_vm.iframeSrc,"title":"客服消息提醒","frameborder":"0","tabindex":"-1","aria-hidden":"true"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }